import { useMutation, useQueryClient } from "react-query";

import { PositionPostSchema } from "~/entity/Positions/model/schema";

import { POSITIONS_QUERY_KEY } from "./useGetPositions";
import { usePositions } from "./usePositions";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: PositionPostSchema;
  options?: MutateOptions;
}

export const useCreatePosition = (
  queryKey: string | any[] = POSITIONS_QUERY_KEY
) => {
  const { positionCreate } = usePositions();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await positionCreate(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось создать должность");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  const create = (data: PositionPostSchema, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };

  return { create, isLoading: mutation.isLoading };
};
